import { useEffect, useState } from 'react';

import { getCitiesFromFrance } from '@/lib/helpers';

import Autocomplete, { type AutocompleteItem, type AutocompleteProps } from '@/components/forms/autocomplete';

interface BirthplaceWS {
    sBirthplace: string;
    sInsee?: string;
}

type AutoCompleteBirthProps<N extends string> = Omit<AutocompleteProps<N>, 'data' | 'setQuery'> & {
    /** Code pays : la recherche des communes n'a lieu que pour la France (`FRA`). */
    country?: string;
};

/** Lieu de naissance, avec recherche des communes françaises à partir de deux lettres. */
export default function AutoCompleteBirth<N extends string>({ country, ...props }: AutoCompleteBirthProps<N>) {
    const [listVilles, setListVilles] = useState<AutocompleteItem[]>([]);
    const [queries, setQueries] = useState<string[]>([]);
    const [query, setQuery] = useState('');

    async function fetchCites(value: string) {
        const cities = await getCitiesFromFrance<BirthplaceWS[]>(value);
        if (!Array.isArray(cities)) {
            return;
        }

        const list = cities.map((c) => ({
            value: c.sBirthplace,
            label: c.sBirthplace,
        }));

        const seen = new Set<string>();
        const newVilles = [...listVilles, ...list].filter((v) => !seen.has(v.label) && !!seen.add(v.label));
        setListVilles(newVilles);
    }

    useEffect(() => {
        if (query && query.length >= 2 && country === 'FRA' && !queries.includes(query)) {
            void fetchCites(query);
            setQueries([...queries, query]);
        }
    }, [query, country]);

    return <Autocomplete data={listVilles} setQuery={setQuery} {...props} />;
}
